const MODAL_HISTORY_STATE_KEY = '__akiveModalIds'

const modalRegistry = new Map()
const closeCallbacks = new Map()
let modalSequence = 0
const MAX_MODAL_REGISTRY_SIZE = 100

function trimModalRegistry() {
  while (modalRegistry.size > MAX_MODAL_REGISTRY_SIZE) {
    const oldestId = modalRegistry.keys().next().value
    modalRegistry.delete(oldestId)
    closeCallbacks.delete(oldestId)
  }
}

export function createModalEntry(type, props) {
  modalSequence += 1
  const entry = { id: `akive-modal-${Date.now()}-${modalSequence}`, type, props }
  modalRegistry.set(entry.id, entry)
  trimModalRegistry()
  return { id: entry.id, type: entry.type }
}

export function getModalHistoryIds(state) {
  const ids = state?.[MODAL_HISTORY_STATE_KEY]
  return Array.isArray(ids) ? ids.filter((id) => typeof id === 'string') : []
}

export function withModalHistoryIds(state, ids) {
  const nextState = { ...(state || {}) }
  if (ids.length > 0) nextState[MODAL_HISTORY_STATE_KEY] = ids
  else delete nextState[MODAL_HISTORY_STATE_KEY]
  return nextState
}

export function resolveModalEntries(ids) {
  return ids
    .map((id) => modalRegistry.get(id))
    .filter(Boolean)
    .map(({ id, type }) => ({ id, type }))
}

export function resolveModalEntry(id) {
  return modalRegistry.get(id)
}

export function runAfterModalClose(id, callback) {
  if (typeof callback === 'function') closeCallbacks.set(id, callback)
}

export function notifyClosedModals(previousIds, currentIds) {
  const currentIdSet = new Set(currentIds)
  previousIds.forEach((id) => {
    if (currentIdSet.has(id)) return
    const callback = closeCallbacks.get(id)
    closeCallbacks.delete(id)
    callback?.()
  })
}
